$(function() {
    $(".module-missions li button").on("click", function(e) {
        let $control = $(this);

        let accordionContent = $control.attr("aria-controls");

        let isAriaExp = $control.attr("aria-expanded");
        let newAriaExp = isAriaExp == "false" ? "true" : "false";
        $control.attr("aria-expanded", newAriaExp);

        let isAriaHid = $("#" + accordionContent).attr("aria-hidden");

        if (isAriaHid == "true") {
            $("#" + accordionContent).attr("aria-hidden", "false");
            $("#" + accordionContent).slideDown("fast", function() {
                $("#" + accordionContent).trigger("accordionToggled");
            });
        } else {
            $("#" + accordionContent).attr("aria-hidden", "true");
            $("#" + accordionContent).slideUp("fast");
        }
    });

    if (iOS()) {
        jQuery(".mission__map-link--apple").css("display", "inline-block");
    }
});

function iOS() {
    var iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod"
    ];
    if (!!navigator.platform) {
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                return true;
            }
        }
    }
    return false;
}
